export type WorkSubTabId =
  | "resumo"
  | "compras"
  | "subempreiteiros"
  | "subempreiteiros-autos"
  | "cronograma"
  | "diario"
  | "custos"
  | "mapa-custos"
  | "variacoes"
  | "financeiro"
  | "materiais"
  | "horas"
  | "dashboard"
  | "balanco"
  | "pos-venda"
  | "marcos"
  | "autos"
  | "contratos"
  | "doc-tecnica"
  | "arquivo-fotografico"
  | "atas";

export type WorkSectionId =
  | "resumo"
  | "execucao"
  | "custos-margens"
  | "facturacao"
  | "documentos";

export interface WorkSubItem {
  id: WorkSubTabId;
  label: string;
}

export interface WorkSection {
  id: WorkSectionId;
  label: string;
  subItems: WorkSubItem[];
}

export const SECTIONS: WorkSection[] = [
  { id: "resumo", label: "Resumo", subItems: [{ id: "resumo", label: "Resumo" }] },
  {
    id: "execucao",
    label: "Execução",
    subItems: [
      { id: "compras", label: "Encomendas" },
      { id: "subempreiteiros", label: "Sub-empreiteiros" },
      { id: "subempreiteiros-autos", label: "Autos de Subempreiteiro" },
      { id: "cronograma", label: "Cronograma" },
      { id: "diario", label: "Diário de Obra" },
    ],
  },
  {
    id: "custos-margens",
    label: "Custos & Margens",
    subItems: [
      { id: "custos", label: "Custos" },
      { id: "mapa-custos", label: "Mapa de Custos e Margens" },
      { id: "variacoes", label: "Variações" },
      { id: "financeiro", label: "Faturas e Despesas" },
      { id: "materiais", label: "Materiais" },
      { id: "horas", label: "Horas" },
      { id: "dashboard", label: "Dashboard Financeiro" },
      { id: "balanco", label: "Balanço Final" },
      { id: "pos-venda", label: "Pós-venda" },
    ],
  },
  {
    id: "facturacao",
    label: "Facturação",
    subItems: [
      { id: "marcos", label: "Marcos" },
      { id: "autos", label: "Autos de Medição" },
    ],
  },
  {
    id: "documentos",
    label: "Documentos",
    subItems: [
      { id: "contratos", label: "Contratos" },
      { id: "doc-tecnica", label: "Documentação Técnica" },
      { id: "arquivo-fotografico", label: "Arquivo Fotográfico" },
      { id: "atas", label: "Atas" },
    ],
  },
];

export function sectionForSubTab(id: WorkSubTabId): WorkSection {
  return SECTIONS.find((section) => section.subItems.some((item) => item.id === id)) ?? SECTIONS[0];
}
